var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9121 18.3121L18.9803 9.26391C18.9418 8.88872 18.6258 8.60355 18.2486 8.60355H5.98781C5.61166 8.60355 5.2958 8.88776 5.25632 9.26196L4.29947 18.3146C4.22051 19.1047 4.48388 19.8987 5.02186 20.4933C5.55988 21.0875 6.323 21.4286 7.11577 21.4286H17.1208C17.9099 21.4286 18.6659 21.0943 19.1941 20.511C19.7297 19.9207 19.9913 19.1203 19.9121 18.3121ZM18.1046 19.523C17.8506 19.803 17.5012 19.9573 17.1208 19.9573H7.11603C6.73815 19.9573 6.37253 19.7927 6.11285 19.5059C5.85315 19.2189 5.72591 18.8381 5.76318 18.4651L6.64986 10.0751H17.5848L18.4484 18.4598C18.4876 18.8577 18.3653 19.2354 18.1046 19.523Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2408 2.57144C9.91519 2.57144 8.02307 4.46352 8.02307 6.78916V9.3394H9.49437V6.78916C9.49437 5.2747 10.7263 4.04273 12.2408 4.04273C13.7553 4.04273 14.9874 5.2747 14.9874 6.78916V9.3394H16.4585V6.78916C16.4585 4.46352 14.5664 2.57144 12.2408 2.57144Z",
    fill: "#212121"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.cebd811b072089908fd8f08a8fea0d86.svg";
export { ForwardRef as ReactComponent };